import { avgEngagementOnReachHistoryConfig } from '@/lib/analytics/charts/facebook/avgEngagementOnReachHistory';
import { avgEngagementRateHistoryConfig } from '@/lib/analytics/charts/facebook/avgEngagementRateHistory';
import { avgEngagementsPostTypeConfig } from '@/lib/analytics/charts/facebook/avgEngagementsPostType';
import { bestTimeToPostConfig } from '@/lib/analytics/charts/facebook/bestTimeToPostConfig';
import { commentsHistoryConfig } from '@/lib/analytics/charts/facebook/commentsHistory';
import { postClickHistoryConfig } from '@/lib/analytics/charts/facebook/postClickHistory';
import { postEngagementHistoryConfig } from '@/lib/analytics/charts/facebook/postEngagementHistory';
import { reactionsDistributionConfig } from '@/lib/analytics/charts/facebook/reactionsDistribution';
import { reactionsHistoryConfig } from '@/lib/analytics/charts/facebook/reactionsHistory';
import { sharesHistoryConfig } from '@/lib/analytics/charts/facebook/sharesHistory';
import { avgClicksPostConfig } from '@/lib/analytics/kpis/facebook/avgClicksPost';
import { avgCommentsConfig } from '@/lib/analytics/kpis/facebook/avgComments';
import { avgEngagementPostConfig } from '@/lib/analytics/kpis/facebook/avgEngagementPost';
import { avgEngagementRateFollowersPostConfig } from '@/lib/analytics/kpis/facebook/avgEngagementRateFollowersPost';
import { avgEngagementReachPostConfig } from '@/lib/analytics/kpis/facebook/avgEngagementReachPost';
import { avgReactionsConfig } from '@/lib/analytics/kpis/facebook/avgReactions';
import { avgSharesConfig } from '@/lib/analytics/kpis/facebook/avgShares';
import { clickRateConfig } from '@/lib/analytics/kpis/facebook/clickRate';
import { clicksConfig } from '@/lib/analytics/kpis/facebook/clicks';
import { commentsConfig } from '@/lib/analytics/kpis/facebook/comments';
import { engagementPost } from '@/lib/analytics/kpis/facebook/engagementPost';
import { reactionsConfig } from '@/lib/analytics/kpis/facebook/reactions';
import { sharesConfig } from '@/lib/analytics/kpis/facebook/shares';
import { mostEngagingPostsConfig } from '@/lib/analytics/widget/facebook/mostEngagingPostsConfig';
import { SIZE_25, SIZE_33, SIZE_50 } from '@/lib/gridElements/size';

export const EngagementFacebook = [
    // Line 1
    { ...avgEngagementRateFollowersPostConfig, size: SIZE_25 },
    { ...avgEngagementReachPostConfig, size: SIZE_25 },
    { ...engagementPost, size: SIZE_25 },
    { ...avgEngagementPostConfig, size: SIZE_25 },

    // Line 2
    { ...reactionsConfig, size: SIZE_33 },
    { ...commentsConfig, size: SIZE_33 },
    { ...sharesConfig, size: SIZE_33 },

    // Line 3
    postEngagementHistoryConfig,

    // Line 4
    mostEngagingPostsConfig,

    // Line 5
    bestTimeToPostConfig,

    // Line 6
    avgEngagementRateHistoryConfig,
    avgEngagementOnReachHistoryConfig,

    // Line 7
    { ...avgReactionsConfig, size: SIZE_50 },
    { ...avgCommentsConfig, size: SIZE_50 },

    // Line 8
    reactionsHistoryConfig,
    commentsHistoryConfig,

    // Line 9
    avgEngagementsPostTypeConfig,
    reactionsDistributionConfig,

    // Line 10
    { ...clicksConfig, size: SIZE_25 },
    { ...avgClicksPostConfig, size: SIZE_25 },
    { ...clickRateConfig, size: SIZE_25 },
    { ...avgSharesConfig, size: SIZE_25 },

    // Line 11
    postClickHistoryConfig,
    sharesHistoryConfig
];

export const requestFacebookParams = [
    [
        'average_engagement_on_reach_per_post',
        'average_engagement_rate_followers_per_post',
        'engagement',
        'post_engagements',
        'average_engagements_per_post',
        'page_consumptions',
        'post_engagements_history',
        'best_time_to_post',
        'reactions',
        'comments',
        'shares',
        'average_reactions',
        'average_comments',
        'average_shares'
    ],
    [
        'average_engagement_rate_history',
        'average_engagement_on_reach_history',
        'reactions_history',
        'comments_history',
        'average_engagements_per_post_type',
        'reactions_distribution',
        'clicks',
        'average_clicks_per_post',
        'click_rate',
        'post_clicks_history',
        'shares_history'
    ]
];
